import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductAdvertising = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#F5E4E7"/>
      <path d="M20 16.6667C24.1421 16.6667 27.5 15.5474 27.5 14.1667C27.5 12.786 24.1421 11.6667 20 11.6667C15.8579 11.6667 12.5 12.786 12.5 14.1667C12.5 15.5474 15.8579 16.6667 20 16.6667Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27.5 20C27.5 21.3833 24.1667 22.5 20 22.5C15.8333 22.5 12.5 21.3833 12.5 20" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 14.1667V25.8334C12.5 27.2167 15.8333 28.3334 20 28.3334C24.1667 28.3334 27.5 27.2167 27.5 25.8334V14.1667" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}

export default ProductAdvertising;

